import React from 'react';
import { useLocation } from 'react-router-dom';
import Layout from './Layout';

const ConditionalLayout = ({ children }) => {
  const { pathname } = useLocation();

  // These pages render standalone — no nav/footer
  if (pathname === '/' || pathname === '/onboarding') {
    return <>{children}</>;
  }

  return <Layout>{children}</Layout>;
};

export default ConditionalLayout;
